<svelte:window on:click={clickHandler} on:keyup={globalKeyHandler} />

<section class="prom-dropdown {notResponsiveClass}" {hidden} bind:this={root}>
    <section class="{arrowClass}"></section>
    <header class="prom-dropdown__header">
        <slot name="header"></slot>
    </header>

    <section class="prom-dropdown__body">
        <section class="prom-dropdown__bodygradient-top"></section>
        {#if items.length}
            {#each items as list, index}
                <List
                    {id}
                    {index}
                    {list}
                    on:click={selectOption}
                    on:dropdownClose
                    on:keyup={keyHandler}
                />
            {/each}
        {:else}
            <slot name="body"></slot>
        {/if}

    </section>

    <footer class="prom-dropdown__footer">
        <slot name="footer"></slot>
    </footer>
</section>

<script>
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import TabTrapHelper from '../../../../lib/helpers/TabTrapHelper';
    import { hideOpenSubmenus, openSubmenus, returnFocusToParentDropdown } from './dropdownHelper.js';
    import List from './List.svelte';
    import { createEventDispatcher, onMount } from 'svelte';

    const dispatch = createEventDispatcher();

    let root;
    let tabTrapper;

    /** @type {boolean} */
    export let arrow = true;
    /** @type {('top'|'bottom')} */
    export let arrowPosition = 'top';
    /** @type {boolean} */
    export let expanded = false;
    /** @type {string} */
    export let id = 'prom-dropdown__list';
    /** @type {{label: string, options: {icon: string, iconsize: number, label: string, link: boolean, url: string, ellipsis: boolean, divider: boolean, iconCssClass: string, target: string, value: string, options: [], cssClass: string } }[]} */
    export let items = [];
    /** @type {boolean} */
    export let responsive = true;

    $: arrowClass = arrow ? `arrow-${arrowPosition}` : '';

    $: hidden = expanded ? undefined : 'hidden';

    $: notResponsiveClass = responsive ? '' : 'prom-dropdown--not-responsive';

    $: if (items || expanded !== null) {
        setTimeout(() => {
            tabTrapper.init();
        }, 0);
    }

    function clickHandler(event) {
        if (!root.contains(event.target)) {
            dispatch('dropdownClose', event);
        }
    }

    function globalKeyHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                if (expanded) {
                    keyHandler(event);
                }
                break;
            case Keys.TAB:
                dispatch('dropdownClose', event);
                break;
            default:
                return;
        }
    }

    function keyHandler(event) {
        const { key } = event;

        switch (normalizeKey(key)) {
            case Keys.ESCAPE:
                if (openSubmenus()) {
                    hideOpenSubmenus();
                    returnFocusToParentDropdown();
                    event.stopPropagation();
                } else {
                    dispatch('dropdownClose', event);
                }
                break;
            case Keys.UP:
                break;
            case Keys.DOWN:
                break;
        default:
            return;
        }
    }

    function selectOption(event) {
        dispatch('selectedOption', { event, data: event.detail.data.value });
        dispatch('dropdownClose', event);
    }

    onMount(() => {
        tabTrapper = new TabTrapHelper(root);
    });
</script>
